module.exports = __webpack_public_path__ + "static/media/img_yesco_promotion_l.8535ba74.png";